import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { WebinarTelemetryService } from 'rainbow-web-sdk/services/webinars/telemetry/webinarTelemetry.service';
import { TelemetryService } from 'rainbow-web-sdk/services/telemetry/telemetry.service';

export class TelemetryPlugin extends Plugin {
    public static initialize(): TelemetryPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[TelemetryPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[TelemetryPlugin] initialized");
            window.rainbow.plugins[TelemetryPlugin.name] = new TelemetryPlugin();

            TelemetryService.getInstance();
            WebinarTelemetryService.getInstance();
        }

        return window.rainbow.plugins[TelemetryPlugin.name];
    }

    private constructor() {
        super();
    }
}
